// Global loading spinner. Backed by TanStack Query's built-in in-flight counters,
// so any useQuery / useMutation contributes automatically.
import { Backdrop, CircularProgress } from '@mui/material';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

export function Loader() {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const isLoading = fetching + mutating > 0;
  return (
    <Backdrop
      open={isLoading}
      sx={{ color: '#fff', zIndex: (t) => t.zIndex.modal + 1 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
